import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { default as React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DROPDOWN_PLATFORM_DATA } from "../../DropdownConstants";
import { GET_ALL_PLATFORM, GET_SERVICE_ACCOUNT } from "../../appConstants";
import "../../components/Headers/Header.css";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";
import AddPlatformModal from "../Modal/AddPlatformModal";
import "../Modal/Modal.css";
import SideBar from "../SideBar/SideBar";
import DataTable from "../Tables/HomePatientTable";
import "../Tables/Table.css";
import LoaderComponent from "./LoaderComponent/LoaderComponent";
import AddServiceAccount from "../ServiceAccount/AddServiceAccount";
import { Tab, Tabs } from "@mui/material";

const PlatformTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setloader] = useState(true);
  const [sortby, setsortby] = useState("");
  const [received, setReceived] = useState(false);
  const [search, setsearch] = useState({});
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState(false);
  const [update, setUpdate] = useState(false);
  const [asc, setAsc] = useState(true);
  const [editData, setEditData] = useState();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [searchWord, setSearchWord] = useState("");
  const [deleteUpdate, setdeleteUpdate] = useState(false);
  const [addServiceAccount, setAddServiceAccount] = useState(false);
  const [selectedTable, setSelectedTable] = useState("platform");
  const [serviceAccountUpdate, setServiceAccountUpdate] = useState(false);

  const handleSearch = (e) => {
    setCount(1);
    const filterobj = { asc: asc, sort_by: sortby, keyword: e.target.value };
    setSearchWord(e.target.value);
    setsearch(filterobj);
  };
  const handlechange = () => {
    const filterobj = { asc: asc, sort_by: sortby, keyword: searchWord };
    setsearch(filterobj);
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };
  const handleclick = () => {
    setAdd(true);
  };

  const handleAddServiceAccount = () => {
    setAddServiceAccount(true);
  };

  const handleModalClose = () => {
    setAdd(false);
    setAddServiceAccount(false);
    setEditData();
  };

  const handleOrder = () => {
    if (sortby !== "") {
      const filterobj = { asc: !asc, sort_by: sortby, keyword: searchWord };
      setsearch(filterobj);
      setAsc((asc) => !asc);
    }
  };

  const handleTableChange = (_, value) => {
    setSelectedTable(value);
  };

  useEffect(() => {
    handlechange();
  }, [sortby]);

  useEffect(() => {
    const data = search;
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_ALL_PLATFORM}?page=${count}&size=10`,
          data,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setData(response.data.items);
        setTotalPages(response.data.pages);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };
    const fetchServiceAccountData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.get(`${GET_SERVICE_ACCOUNT}`, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        if (response?.status === 200 && response?.data) {
          let res = response?.data?.message?.service_accounts;
          setData(res);
          setTotalPages(1);
          setloader(true);
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };

    if (selectedTable === "platform") {
      fetchData();
    } else if (selectedTable === "service") {
      fetchServiceAccountData();
    }
  }, [
    search,
    count,
    update,
    deleteUpdate,
    selectedTable,
    serviceAccountUpdate,
  ]);

  useEffect(() => {
    setReceived(true);
  }, [data]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated !== "true") {
      navigate("/login");
    }
  });

  return (
    <div className="d-flex min-vh-100  background">
      <SideBar />
      <div>
        <HomeHeader />
        <div className="d-flex flex-column">
          {received && (
            <div>
              <div className="header">
                <h1 className="header-text">PLATFORM DATA</h1>

                <div className="d-flex justify-content-between mb-5">
                  <div className="d-flex justify-content-start gap-3">
                    <div>
                      <h6
                        style={{
                          fontFamily: "Montserrat",
                          color: "#0fc4a0",
                          fontSize: "14px",
                        }}
                      >
                        Sort by
                        <span style={{ color: "black" }}>&nbsp;||&nbsp;</span>
                        <span
                          style={{
                            color: "rgb(249, 215, 161)",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            onClick={handleOrder}
                            style={{ fontFamily: "Montserrat" }}
                          >
                            {asc ? "Desc" : "Asc"}
                          </span>
                          {asc ? (
                            <i className="fa fa-sort-amount-asc"></i>
                          ) : (
                            <i className="fa fa-sort-amount-desc"></i>
                          )}
                        </span>
                      </h6>
                      <Select
                        displayEmpty
                        placeholder="Sort by"
                        className="sort"
                        name="Sort"
                        value={sortby || ""}
                        onChange={(e) => {
                          setsortby(e.target.value);
                        }}
                        style={{ color: "white", height: "39px" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              backgroundColor: "#121c1b",
                              color: "white",
                              borderRadius: "5px",
                              border: "1px solid #0fc4a0",
                            },
                          },
                        }}
                      >
                        <MenuItem value="" style={{ fontSize: "14px" }}>
                          Select
                        </MenuItem>

                        {data &&
                          data.length > 0 &&
                          DROPDOWN_PLATFORM_DATA.map((option) => (
                            <MenuItem
                              key={option.label}
                              value={option.value}
                              style={{ fontSize: "14px" }}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </div>
                    <div className="mr-4 d-flex flex-column justify-content-between">
                      <h6
                        style={{
                          fontFamily: "Montserrat",
                          color: "#0fc4a0",
                          fontSize: "14px",
                        }}
                      >
                        Search
                      </h6>
                      <input
                        style={{ height: "39px" }}
                        type="search"
                        placeholder="Search here"
                        className="search"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn-class  mr-4 shadow custom-add-button"
                      onClick={handleAddServiceAccount}
                    >
                      Add Service Account
                    </button>
                    <button
                      type="button"
                      className="btn-class  mr-4 shadow custom-add-button"
                      onClick={handleclick}
                    >
                      ADD
                    </button>
                  </div>
                </div>
              </div>
              {loader ? (
                <div>
                  <div className="tab-container d-flex content-center">
                    <Tabs
                      value={selectedTable}
                      onChange={handleTableChange}
                      classes={{ indicator: "tab-indicator" }}
                      variant="fullWidth"
                      className="w-100"
                    >
                      <Tab
                        value="platform"
                        label="Platform Table"
                        className="label-fields"
                      />
                      <Tab
                        value="service"
                        label="Service Account Table"
                        className="label-fields"
                      />
                    </Tabs>
                  </div>

                  {selectedTable === "platform" && (
                    <DataTable
                      viewTable={received}
                      setViewTable={setReceived}
                      handlePage={handlePageChange}
                      count={count}
                      totalPages={totalPages}
                      data={data}
                      type={"platformTable"}
                      setAdd={setAdd}
                      setEditData={setEditData}
                      deleteAlert={deleteAlert}
                      setDeleteAlert={setDeleteAlert}
                      setdeleteUpdate={setdeleteUpdate}
                    />
                  )}

                  {selectedTable === "service" && (
                    <DataTable
                      viewTable={received}
                      setViewTable={setReceived}
                      handlePage={handlePageChange}
                      count={count}
                      totalPages={totalPages}
                      data={data}
                      type={"serviceAccountTable"}
                      setAdd={setAdd}
                      setEditData={setEditData}
                      deleteAlert={deleteAlert}
                      setDeleteAlert={setDeleteAlert}
                      setdeleteUpdate={setdeleteUpdate}
                    />
                  )}
                </div>
              ) : (
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ margin: "10vw 48vw" }}
                >
                  <div>
                    <LoaderComponent />
                  </div>
                </div>
              )}
            </div>
          )}
          {add && (
            <AddPlatformModal
              ModalState={add}
              handleClose={handleModalClose}
              setUpdate={setUpdate}
              editData={editData}
            />
          )}
          {addServiceAccount && (
            <AddServiceAccount
              ModalState={addServiceAccount}
              handleClose={handleModalClose}
              setServiceAccountUpdate={setServiceAccountUpdate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PlatformTable;
